import { useEffect, useState } from 'react'
import { useAppStore } from '../store'
import { mapCardStyle } from './MapOverlays'

const VIEWPORT_QUERY_MIN_ZOOM = 6

/**
 * Small pill anchored just above the time bar that surfaces transient map
 * states — currently "Zoom in for region query". Kept off in the rail so
 * status stays where the user is looking (the map itself).
 */
const MapStatus = () => {
  const sidebarWidth = useAppStore((s) => s.sidebarWidth) ?? 0
  const rightRailWidth = useAppStore((s) => s.rightRailWidth)
  const mapInstance = useAppStore((s) => s.mapInstance)
  const [zoom, setZoom] = useState<number | null>(null)

  useEffect(() => {
    if (!mapInstance) {
      setZoom(null)
      return
    }
    const read = () => {
      try { setZoom(mapInstance.getZoom()) } catch { /* noop */ }
    }
    read()
    mapInstance.on?.('zoom', read)
    return () => {
      mapInstance.off?.('zoom', read)
    }
  }, [mapInstance])

  if (zoom === null || zoom > VIEWPORT_QUERY_MIN_ZOOM) return null

  return (
    <div
      role="status"
      style={{
        ...mapCardStyle,
        left: '50%',
        right: 'auto',
        transform: `translate(calc(-50% + ${(sidebarWidth - rightRailWidth) / 2}px), 0)`,
        top: 10,
        padding: '4px 10px',
        fontFamily: 'var(--card-sans)',
        fontSize: 11,
        color: 'var(--slate)',
        pointerEvents: 'none',
        zIndex: 95,
      }}
    >
      Zoom in for region query
    </div>
  )
}

export default MapStatus
